import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// An EV charging hub: a solar-roofed canopy on two columns sheltering a row of
// charge posts over marked parking bays. A station where several vehicles
// charge at once.
const STEEL = "#878e96";
const STEEL_DK = "#6c727a";
const CELL = "#244a8c";
const ROOF = "#9aa0a6";
const PAD = "#5a5a5e";
const BAY = "#cfcfcf";
const POST = "#3a6b4a";
const SCREEN = "#2a6f9e";

function chargePost(x: number): Part[] {
  return [
    { geometry: new THREE.BoxGeometry(0.18, 0.6, 0.14), color: POST, position: [x, 0.3, 0.3] },
    { geometry: new THREE.BoxGeometry(0.12, 0.16, 0.02), color: SCREEN, position: [x, 0.42, 0.38] },
    { geometry: new THREE.BoxGeometry(0.04, 0.1, 0.05), color: "#3a3a3e", position: [x + 0.1, 0.32, 0.34] },
  ];
}

export const chargingHub = defineModel({
  id: "charging-hub",
  batchId: "electric",
  name: "Charging hub",
  tags: ["building", "electric", "power", "charging", "ev", "solar"],
  summary: "A solar-roofed canopy over a row of EV charge posts and bays.",
  footprint: 1.0,
  parts(): Part[] {
    const parts: Part[] = [
      { geometry: new THREE.BoxGeometry(2.0, 0.06, 1.3), color: PAD, position: [0, 0.03, 0] },
    ];
    // Painted bay dividers.
    for (const x of [-0.66, 0, 0.66]) {
      parts.push({ geometry: new THREE.BoxGeometry(0.04, 0.01, 0.9), color: BAY, position: [x, 0.07, 0.1] });
    }
    // Two columns and the canopy.
    for (const x of [-0.8, 0.8]) {
      parts.push({ geometry: new THREE.BoxGeometry(0.1, 1.3, 0.1), color: STEEL, position: [x, 0.65, -0.4] });
    }
    parts.push({ geometry: new THREE.BoxGeometry(2.0, 0.08, 1.0), color: ROOF, position: [0, 1.34, -0.05], rotation: [-0.12, 0, 0] });
    // Solar cells on the canopy roof.
    for (const x of [-0.6, 0, 0.6]) for (const z of [-0.25, 0.2]) {
      parts.push({ geometry: new THREE.BoxGeometry(0.5, 0.02, 0.4), color: CELL, position: [x, 1.39 + z * 0.12, z - 0.05], rotation: [-0.12, 0, 0] });
    }
    // A row of charge posts.
    parts.push(...chargePost(-0.66), ...chargePost(0.0), ...chargePost(0.66));
    // Canopy fascia.
    parts.push({ geometry: new THREE.BoxGeometry(2.0, 0.1, 0.06), color: STEEL_DK, position: [0, 1.3, 0.45] });
    return parts;
  },
  animations: [],
});
